<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      2. {{ $t('common_words.verify_inputed_information') }}
    </p>
    <div class="row d-flex justify-content-center">
      <div class="col-10">
        <table class="table">
          <tbody>
            <tr class="shadow-sm">
              <td><strong>{{ $t('common_words.company') }}:</strong> {{ infoData.business_name }}</td>
              <td><strong>{{ $t('common_words.farm') }}:</strong> {{ infoData.farm_name }}</td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex flex-nowrap overflow-auto pb-3">
          <div
            v-for="(_, index) in infoData.names"
            :key="index"
            class="border rounded-sm shadow-sm p-3 mr-3 flex-shrink-0"
            style="min-width: 280px"
          >
            <strong>{{ $t('common_words.code') }}:</strong> {{ infoData.codes[index] }}<br />
            <strong>{{ $t('common_words.name') }}:</strong> {{ infoData.names[index] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'valves-step-confirm',
  props: {
    infoData: { type: Object, required: true },
  },
};
</script>
